import { Box } from '@mui/material'

import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'

import { Footer } from './Footer'
import { Header } from './Header'
import { Body } from './Body/Body'

export function Content() {
  const { ready } = useConfigureController()

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Box paddingTop={2} maxWidth={400}>
        <Body />
      </Box>
    </ModalContent>
  )
}
